import { useTranslation } from 'react-i18next';

import { useStopImpersonating } from '~/api/auth';
import { useIsImpersonating, useUser } from '~/api/user';
import { Alert, Button } from '~/components';

import { actionWrapperStyle, bannerWrapperStyle } from './ImpersonationBanner.css';

export const ImpersonationBanner = () => {
  const { data: user } = useUser();
  const isImpersonating = useIsImpersonating();
  const stopImpersonating = useStopImpersonating();

  const { t } = useTranslation(['common']);

  if (!isImpersonating) return null;

  return (
    <div className={bannerWrapperStyle}>
      <Alert
        announce
        icon="Warning"
        status="warning"
        title={t('common:impersonationBanner.title', { name: `${user.firstName} ${user.lastName}` })}
      >
        <p>{t('common:impersonationBanner.description')}</p>

        <div className={actionWrapperStyle}>
          <Button emphasis="tertiary" icon="Logout" loading={stopImpersonating.isPending} onClick={() => stopImpersonating.mutate()}>
            {t('common:impersonationBanner.stop')}
          </Button>
        </div>
      </Alert>
    </div>
  );
};
